import { isIE } from "./common";

let logRocketPromise = null;
let initializedLogRocketPromise = null;

const loadLogRocket = () => {
  if (typeof window === "undefined" || isIE()) {
    return Promise.resolve(null);
  }

  if (!logRocketPromise) {
    logRocketPromise = import("logrocket")
      .then(module => module.default || module)
      .catch(error => {
        logRocketPromise = null;

        if (IS_DEBUG) {
          console.error(error);
        }

        return null;
      });
  }

  return logRocketPromise;
};

export const initLogRocket = (appId, options) => {
  if (!appId) {
    return Promise.resolve(null);
  }

  if (!initializedLogRocketPromise) {
    initializedLogRocketPromise = loadLogRocket()
      .then(logRocket => {
        if (!logRocket) {
          return null;
        }

        logRocket.init(appId, options);
        return logRocket;
      })
      .catch(error => {
        initializedLogRocketPromise = null;

        if (IS_DEBUG) {
          console.error(error);
        }

        return null;
      });
  }

  return initializedLogRocketPromise;
};

export const captureLogRocketException = (error, options) =>
  initializedLogRocketPromise
    ? initializedLogRocketPromise.then(logRocket => {
        if (logRocket) {
          logRocket.captureException(error, options);
        }

        return logRocket;
      })
    : Promise.resolve(null);

export const getLogRocketSessionURL = callback =>
  initializedLogRocketPromise
    ? initializedLogRocketPromise.then(logRocket => {
        if (logRocket) {
          logRocket.getSessionURL(callback);
        }

        return logRocket;
      })
    : Promise.resolve(null);
